<script>
  import { onMount } from 'svelte';

  export let width = "";
  export let rotate = "";
  export let margin = "";

  onMount(() => {
    animationIn();
  });

  function animationIn() {
  var animationIn_TL = new TimelineMax();
      animationIn_TL.add("init")
                    .from([".hotspot-line"],1, {borderWidth:'0' }, "init")
                    .from([".hotspot-line"],0.75, {scale:0, }, "init")
                    .to([".hotspot-line"], 1, {opacity:1}, "init");
 }
</script>

<style>
  .hotspot-line {
    pointer-events: none;
		-webkit-user-select: none;
		-moz-user-select: none;
		-ms-user-select: none;
		user-select: none;
    
    position: absolute;
    border-top: solid 0.15rem #149ed9;
  }
</style>

<div
  class="hotspot-line"
  style="width: {width}; margin:{margin}; transform:{rotate}" />
